import { TweenMax, Power4 } from "gsap/TweenMax";
import 'animation.gsap'
import Barba from 'barba.js';

  export var FadeOutTransition = Barba.BaseTransition.extend({
    start: function() {
      /**
       * This function is automatically called as soon the Transition starts
       * this.newContainerLoading is a Promise for the loading of the new container
       * (Barba.js also comes with an handy Promise polyfill!)
       */

      // As soon the loading is finished and the old page is faded out, let's fade the new page
      Promise
        .all([this.newContainerLoading])
        .then(this.fadeIn.bind(this));
    },

    fadeIn: function() {
      /**
       * this.newContainer is the HTMLElement of the new Container
       * At this stage newContainer is on the DOM (inside our #barba-container and with visibility: hidden)
       * Please note, newContainer is available just after newContainerLoading is resolved!
       */

      var _this = this;



      $(this.newContainer).css({'visibility': 'visible', 'top': '0', 'z-index' : 1, 'opacity': 0});
      $(this.oldContainer).css({'position': 'absolute', 'top': '0', 'z-index' : 2});
      TweenMax.to($(this.oldContainer)[0], 0.5, {
        opacity: 0,
        ease: Power4.easeIn,
        onComplete: function () {
          $(_this.newContainer).css({'opacity': 1});

          window.oldContainer = _this.oldContainer;

         if (document.getElementById('casestudies') && _this.oldContainer.querySelector('.case-study-single')) {
          // Force the browser to jump to the 'casestudies' section immediately


            document.getElementById('casestudies').scrollIntoView();

        } else {
          window.scrollTo(0, 0);
        }


          _this.done();
        },
      });
    },
  });



// WEBPACK FOOTER //
// ./scripts/transitions/fade-out-transition.js